const features = [
  {
    icon: "ri-file-list-3-line",
    title: "结构化解构",
    text: "每个词条固定分为背景、经过、完整记录与回应四段，不靠情绪叙述，读者可以按顺序快速建立认知。",
  },
  {
    icon: "ri-timeline-view",
    title: "可追溯时间线",
    text: "关键节点按日期排列，标注每一个转折发生在什么时候、由谁推动，避免事件被压缩成一句模糊的结论。",
  },
  {
    icon: "ri-scales-3-line",
    title: "多方回应并列",
    text: "当事各方、平台或主办方的公开说法并列呈现，不替任何一方定性，让读者自己判断信息的完整度。",
  },
  {
    icon: "ri-eye-off-line",
    title: "拒绝人身攻击",
    text: "站内只整理公开可查的信息，明确区分「讨论事件」与「挖掘个人」，倡导理性看待、不信谣不传谣。",
  },
];

export default function Features() {
  return (
    <section className="w-full border-b border-background-200 bg-background-100 px-4 py-14 md:px-10 md:py-20">
      <div className="mb-10 max-w-3xl md:mb-14">
        <span className="font-heading text-sm font-bold tracking-[0.2em] text-primary-600">
          WHY HEILIAO WIKI
        </span>
        <h2 className="mt-3 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-4xl">
          我们不做情绪放大器，只做事件的整理者
        </h2>
        <p className="mt-4 text-base leading-relaxed text-foreground-600">
          一个热点从发酵到沉寂，往往只需要三天。我们希望留下的是可回看的记录，而不是被不断转述的片段。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {features.map((item) => (
          <article
            key={item.title}
            className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-md bg-accent-100 text-accent-700">
              <i className={`${item.icon} text-2xl`} />
            </span>
            <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}